import { render, staticRenderFns } from "./ModalReportDetailDragonTiger.vue?vue&type=template&id=54542729&"
import script from "./ModalReportDetailDragonTiger.vue?vue&type=script&lang=js&"
export * from "./ModalReportDetailDragonTiger.vue?vue&type=script&lang=js&"
import style0 from "./ModalReportDetailDragonTiger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports